export const useRandomSeed = () => {
  return useState("randomSeed", () => Date.now() % 1000);
};
